import * as admin from 'firebase';


  var config = { /* COPY THE ACTUAL CONFIG FROM FIREBASE CONSOLE */
    apiKey: "AIzaSyDM0UCIgf95uQPd1qqIoEC0yHuNeV8HC5w",
    authDomain: "cyberponics-2017.firebaseapp.com",
    databaseURL: "https://cyberponics-2017.firebaseio.com",
    storageBucket: "cyberponics-2017.appspot.com",
    messagingSenderId: "770259072738"
  };
  export var fire = admin.initializeApp(config);
  



// WEBPACK FOOTER //
// ./src/components/fire.jsx